var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEquipodetrabajo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 640,
    viewBox: "0 0 360 640",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_435)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_134_435)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-27.2083 393.348C-34.6693 383.021 -50.4121 378.631 -50.9597 364.388C-51.5068 350.156 -48.4901 331.451 -40.66 316.662C-33.5658 303.264 -51.4447 282.011 -42.346 269.353C-30.7628 253.239 11.5459 230.233 29.2307 225.84C48.0609 221.163 52.5265 258.032 68.4477 262.66C81.4355 266.436 100.322 254.498 112.431 259.707C125.575 265.36 133.281 278.082 137.078 292.179C141.181 307.415 146.385 326.236 134.8 342.762C122.577 360.198 96.5016 358.273 80.5143 372.869C65.3556 386.708 64.5833 411.013 47.7309 422.252C31.0699 433.362 10.2958 434.824 -4.07773 429.28C-18.0951 423.874 -18.7571 405.046 -27.2083 393.348Z",
    fill: "url(#paint0_linear_134_435)",
    fillOpacity: 0.6
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_134_435",
    x: -107.022,
    y: 169.431,
    width: 304.894,
    height: 318.992,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28,
    result: "effect1_foregroundBlur_134_435"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_134_435",
    x1: 140.752,
    y1: 432.67,
    x2: 111.657,
    y2: 200.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E24473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#620C90"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 640,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipodetrabajo);
export default __webpack_public_path__ + "static/media/equipodetrabajo.dee9a0597d40e9052690582249470661.svg";
export { ForwardRef as ReactComponent };